import React from 'react';
import PropTypes from 'prop-types';
import { MFELoader } from '@jarvis/react-portal-addons';
import { getModuleInitializedEvent, publishEvent } from '../../utils/analytics';

const NotificationWidget = ({
  stack,
  properties,
}) => (
  <MFELoader
    analytics={{
      enable: true,
      events: {
        moduleDisplayed: {
          activity: 'Home-v01',
        },
      },
    }}
    card
    component="@jarvis/react-smb-notifications"
    data-testid="smart-notification-widget-mfe"
    header={false}
    onLoad={() => {
      publishEvent(getModuleInitializedEvent('ReactSmbNotifications'));
    }}
    properties={properties}
    stack={stack}
    type="SMBSmartNotification"
  />
);

NotificationWidget.propTypes = {
  stack: PropTypes.number,
  properties: PropTypes.shape(PropTypes.any),
};

NotificationWidget.defaultProps = {
  stack: 0,
  properties: {},
};

export default NotificationWidget;
